import { render, staticRenderFns } from "./applicationMessage.vue?vue&type=template&id=063c012c&scoped=true&"
import script from "./applicationMessage.vue?vue&type=script&lang=js&"
export * from "./applicationMessage.vue?vue&type=script&lang=js&"
import style0 from "./applicationMessage.vue?vue&type=style&index=0&id=063c012c&lang=scss&scoped=true&"
import style1 from "./applicationMessage.vue?vue&type=style&index=1&lang=scss&"
import style2 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063c012c",
  null
  
)

export default component.exports